import React from 'react'
import PropTypes from 'prop-types'
import { IconSLIWrapper } from './IconSLIWrapper'

export const IconFileBookmark = ({
  className,
  'data-mu-test': dataAttributeTest,
  'data-tip': dataTip
}) => {
  return (
    <IconSLIWrapper
      className={className}
      data-mu-test={dataAttributeTest}
      data-tip={dataTip}
    >
      <svg preserveAspectRatio='xMidYMid' viewBox='0 0 24 24'>
        <path
          shapeRendering='geometricPrecision'
          fill='currentColor'
          fillRule='evenodd'
          d="M17.931,18.062 C17.926,18.153 17.908,18.240 17.878,18.326 C17.867,18.358 17.859,18.389 17.845,18.420 C17.797,18.524 17.736,18.623 17.652,18.707 L12.672,23.706 C12.580,23.799 12.471,23.872 12.349,23.923 C12.228,23.973 12.098,24.000 11.967,24.000 L2.012,24.000 C0.911,24.000 0.014,23.100 0.014,21.994 L0.014,3.006 C0.014,1.900 0.911,1.000 2.012,1.000 L4.031,1.000 C4.031,0.448 4.445,0.000 4.995,0.000 L8.979,0.000 C9.529,0.000 9.975,0.448 9.975,1.000 L15.946,1.000 C17.047,1.000 17.944,1.900 17.944,3.006 L17.944,18.000 C17.944,18.022 17.933,18.040 17.931,18.062 ZM12.963,20.586 L14.543,19.000 L12.963,19.000 L12.963,20.586 ZM8.031,2.239 C8.011,2.161 7.983,2.085 7.983,2.000 L5.991,2.000 L5.991,7.382 L6.541,7.105 C6.681,7.035 6.834,7.000 6.987,7.000 C7.139,7.000 7.292,7.035 7.432,7.105 L8.031,7.000 L8.031,2.239 ZM9.975,3.000 L9.975,9.000 C9.975,9.347 9.796,9.669 9.503,9.851 C9.343,9.950 9.161,10.000 8.979,10.000 C8.827,10.000 8.674,9.965 8.533,9.895 L6.987,9.118 L5.440,9.895 C5.131,10.049 4.765,10.033 4.471,9.851 C4.177,9.669 4.031,9.347 4.031,9.000 L4.031,3.000 L2.012,3.000 L2.006,21.994 L11.031,21.999 L11.031,18.000 C11.031,17.448 11.417,17.000 11.967,17.000 L16.031,17.000 L16.031,3.000 L9.975,3.000 Z"
        />
      </svg>
    </IconSLIWrapper>
  )
}

IconFileBookmark.propTypes = {
  className: PropTypes.string,
  'data-mu-test': PropTypes.string,
  'data-tip': PropTypes.string
}
